// "▲ +$312.40 (+0.6%)" / "▼ −$1,248.10 (−2.3%)" -- the arrow is never the
// only signal, the sign prefix always accompanies it (§1.2/§1.3).
import { formatDelta, useMoneyFormat } from '@/lib/money';

export type DeltaDirection = 'up' | 'down' | 'flat';

const DIRECTION_CLASS: Record<DeltaDirection, string> = {
  up: 'text-money-positive',
  down: 'text-money-negative',
  flat: 'text-money-neutral',
};

export function DeltaText({
  value,
  percent,
  direction,
  className,
}: {
  value: string;
  percent?: string;
  direction: DeltaDirection;
  className?: string;
}) {
  const { currency, masked } = useMoneyFormat();
  const { text } = formatDelta(value, { percent, currency, masked });

  return (
    <span
      className={['ms-tabular', DIRECTION_CLASS[direction], className].filter(Boolean).join(' ')}
      aria-label={text}
      data-testid="delta-text"
    >
      {text}
    </span>
  );
}

export default DeltaText;
